import * as qplsService from '../../../../services/Qpls/qplsService.js';
import * as daHelper from '../../../Dialogs/dialogActionsHelper';
import {dialogsNames} from '../../../../enums/dialogsNames';


const config = {
  getSubmitMethod: () => qplsService.createQplTestField,
};

export const actionTypes = {
  ...daHelper.getActionTypes(dialogsNames.CREATE_QPL_TEST_FIELD_DIALOG),
};

const actions = {
  ...daHelper.getActions(dialogsNames.CREATE_QPL_TEST_FIELD_DIALOG),

};

export let api = {
  ...daHelper.getApiActions(actions, config),
}

export let jsxActions = {
  ...daHelper.getJsxActions(api),

};
